<template>
    <div>               
        <!-- alerts -->
        <div class="p-10">
            <div v-show="correoEnviado" class="alert-success">
                <button type="button" class="btn-close-success" data-dismiss="alert-error"></button>
                <p>Correo Enviado</p>
            </div>

            <div v-if="inputError(errores, 'correo', 'has-error')"  class="alert-error">
                <button type="button" class="btn-close-error" data-dismiss="alert-error"></button>
                <p>Por favor revise los campos!!!</p>
            </div>
        </div>

        <div v-if="loading" class="loader"></div>
        <div v-show="!loading && !correoEnviado">

            <div class="col-6 p-10">
                <input type="text" placeholder="Nombre" name="nombre" v-model="contacto.nombre"
                :class="inputError(errores, 'nombre', 'has-error')" >
                <span class="help-block" v-if="inputError(errores, 'comentario', 'has-error')" style="margin-bottom: 10px;">
                    <strong>{{ errores['nombre'][0] }}</strong>
                </span>
            </div>
            <div class="col-6 p-10">
                <input type="email" placeholder="Correo" name="email" v-model="contacto.correo"
                :class="inputError(errores, 'correo', 'has-error')"/>
                <span class="help-block" v-if="inputError(errores, 'correo', 'has-error')">
                    <strong>{{ errores['correo'][0] }}</strong>
                </span>
            </div>

            <div class="clear"></div>
            <div class="col-6 p-10">
                <input type="text" placeholder="Asunto" name="nombre" v-model="contacto.asunto"
                :class="inputError(errores, 'asunto', 'has-error')" >
                <span class="help-block" v-if="inputError(errores, 'comentario', 'has-error')" style="margin-bottom: 10px;">
                    <strong>{{ errores['asunto'][0] }}</strong>
                </span>
            </div>
            <div class="col-6 p-10">
                <input type="tel" placeholder="Teléfono" name="telefono" v-model="contacto.telefono"
                :class="inputError(errores, 'telefono', 'has-error')"/>
            </div>

            <div class="col-12" style="padding:0 10px 0 10px">
                <textarea placeholder="Comentario" name="descripcion" v-model="contacto.comentario"
                :class="inputError(errores, 'comentario', 'has-error')"></textarea>
                <span class="help-block" v-if="inputError(errores, 'comentario', 'has-error')" style="margin-bottom: 10px;">
                    <strong>{{ errores['comentario'][0] }}</strong>
                </span>
            </div>

            <div class="clear"></div>
            <input type="submit" value="Enviar" name="submit" @click="enviarCorreo">
        </div>
    </div>
</template>

<script>
import tools from '../tools'
import axios from '../axios'

export default {
    data() {
        return {
            loading: false,
            correoEnviado: false,
            contacto: {
                nombre: '',
                correo: '',
                asunto: '',
                telefono: '',
                comentario: ''
            },
            errores: null
        }
    },
    methods: {
        enviarCorreo() {
            this.loading = true
            axios.post('/contacto', {...this.contacto}).then(() => {
                this.loading = false
                this.correoEnviado = true
            }).catch(error => {
                console.log(error.message)
                this.loading = false
                this.errores = error.response.data.errors
            })
        },
        inputError: tools.inputError
    }
}
</script>